import React from 'react';
import { AICopyGenerator } from '../components/AICopyGenerator';

/**
 * AI Copy Studio Page
 * Story: E007-S024 - AI Copy Suggestions
 * 
 * Full-featured AI copy generation studio with:
 * - GPT-4 powered copy generation
 * - Competitor analysis
 * - A/B test variants
 * - Sentiment analysis
 * - Compliance checking
 */
const AICopyStudioPage: React.FC = () => {
  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
          AI Copy Studio
        </h1>
        <p className="mt-2 text-gray-600 dark:text-gray-400">
          Generate high-performing ad copy with GPT-4, analyze competitors, create A/B tests, and check compliance.
        </p>
      </div>

      <AICopyGenerator />
    </div>
  );
};

export default AICopyStudioPage;
